export const LeaderboardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#1D1C1C"
      stroke-width="1.35"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="5" y1="21" x2="5" y2="11"></line>
      <line x1="12" y1="21" x2="12" y2="4"></line>
      <line x1="19" y1="21" x2="19" y2="14"></line>
    </svg>
  );
};
